import { useCallback } from "react";
import { Flex, useColorMode, useColorModeValue } from "@chakra-ui/react";

import { MoonNightMode, Sun } from "icons";
import { IconBackgroundContainer } from "theme";

import Icon from "@components/Icon";

const LIGHT = "light";
const DARK = "dark";

const ThemeSwitcher = () => {
  const selectedTheme = useColorModeValue(LIGHT, DARK);
  const { toggleColorMode } = useColorMode();

  const onChangeTheme = useCallback(() => {
    toggleColorMode();
  }, [toggleColorMode]);

  return (
    <Flex
      borderRadius="32px"
      bg="iconBackground"
      p="4px"
      onClick={onChangeTheme}
    >
      <IconBackgroundContainer
        h="24px"
        w="24px"
        bg={selectedTheme === DARK ? "backgroundSecondary" : "inherit"}
        color={selectedTheme === DARK ? "textPrimary" : "textSecondary"}
        _light={{
          color: selectedTheme === DARK ? "primary" : "textSecondary",
        }}
      >
        <Icon Icon={MoonNightMode} width="15px" height="15px" />
      </IconBackgroundContainer>

      <IconBackgroundContainer
        h="24px"
        w="24px"
        bg={selectedTheme === LIGHT ? "backgroundSecondary" : "inherit"}
        color={selectedTheme === LIGHT ? "textPrimary" : "textSecondary"}
        _light={{
          color: selectedTheme === LIGHT ? "primary" : "textSecondary",
        }}
        ml="4px"
      >
        <Icon Icon={Sun} width="15px" height="15px" />
      </IconBackgroundContainer>
    </Flex>
  );
};

export default ThemeSwitcher;
